import React, { useContext } from 'react';
import OrderTable from './OrderTable';
import { CommonContext, GaintOFDOrdersContext } from '../../context';
import OrdersTab from './OrdersTab';
import { Box, CardHeader, Paper } from '@mui/material';
import ActionGroup from './ActionGroup';
import AlertMessage from '../common/AlertMessage';
import Loader from '../common/Loader';
import FilterBar from './FilterBar';
import OrderDetails from './OrderDetails';
import TrackOrder from './TrackOrder';

export default function GaintOFDOrdersView() {
    const { openAlert } = useContext(CommonContext);
    const { isLoading } = useContext(GaintOFDOrdersContext);

    return (
        <div className='main-screen'>
            {openAlert && <AlertMessage />}
            {isLoading && <Loader />}
            <OrderDetails />
            <TrackOrder />
            <Box className="component-header">
                <CardHeader title="Gaint OFD Orders" />
            </Box>
            <ActionGroup />
            <Paper sx={{ boxShadow: 'none' }}>
                <OrdersTab />
                <FilterBar />
                <OrderTable />
            </Paper>
        </div>
    );
}
